
<script>
  import MTableCellDefault from 'components/Data/Tables/MTable/cells/MTableCellDefault';
  import {mdash} from 'utils/typing/symbols';

  export default {
    name: 'MTableCellMdash',
    extends: MTableCellDefault,
    computed: {
      value () {
        return mdash;
      }
    }
  };
</script>
